import { siteContent } from '../lib/siteContent';

/** Crawlable text for search engines — not shown on the living homepage UI */
export default function AvatarSeoHidden() {
  return (
    <div className="sr-only" aria-hidden="false">
      <h2>The SELF Labs Ecosystem</h2>
      <p>
        SELF Labs is an AI-native innovation lab. Talk to Milan, Founder and CEO of SELF Labs Inc,
        to explore SELF Phone, SELF OS, Resonatia, Role Model AI, Living Website (get your own),
        AuRA Resonant Layer, Harmony Encoder Studio, products, AI avatars, living websites,
        robotics, BCI, partnerships, demos, and milancheeks.com.
      </p>
      <ul>
        {siteContent.map((item) => (
          <li key={item.id}>
            <a href={item.ctaHref.startsWith('http') ? item.ctaHref : item.ctaHref}>
              {item.title}
            </a>
            : {item.shortDescription}
          </li>
        ))}
      </ul>
    </div>
  );
}
